export default function (dependencies) {
  return {
    imports: dependencies.reduce((acc, curr) => {
      const { name, url, context } = curr
      const isSuite = name.startsWith('zsuite')
      const importAlias = isSuite ? `@zsuite/${name.replace('zsuite-', '')}` : `@platform/${name}`

      const mapped = { ...acc, [importAlias]: url }
      const withRawName = { ...mapped, ...(isSuite ? { [name]: url } : {}) }

      if (context === 'APP') return withRawName
      if (context === 'SUITE') return withRawName
      if (context === 'COMMON') return withRawName
      return withRawName
    }, {}),
  }
}
